import IconChessClassic from '@/components/layout/icons/ChessClassic/ChessClassic.vue';
import IconChessMarseille from '@/components/layout/icons/ChessMarseille/ChessMarseille.vue';
import IconChess960 from '@/components/layout/icons/Chess960/Chess960.vue';
import IconChessBughouse from '@/components/layout/icons/ChessBughouse/ChessBughouse.vue';
import IconChessDoubles from '@/components/layout/icons/ChessDoubles/ChessDoubles.vue';
import IconChessHandAndBrain from '@/components/layout/icons/ChessHandAndBrain/ChessHandAndBrain.vue';
import { ChessVariant } from '@/services/utils/enums';

const VARIANT_COMPONENTS = {
  [ChessVariant.CLASSIC]: 'IconChessClassic',
  [ChessVariant.MARSEILLAIS]: 'IconChessMarseille',
  [ChessVariant.CHESS960]: 'IconChess960',
  [ChessVariant.BUGHOUSE]: 'IconChessBughouse',
  [ChessVariant.DOUBLES_2X2]: 'IconChessDoubles',
  [ChessVariant.HAND_AND_BRAIN]: 'IconChessHandAndBrain',
};

export default {
  name: 'IconChessVariant',
  components: {
    IconChessClassic,
    IconChessMarseille,
    IconChess960,
    IconChessBughouse,
    IconChessDoubles,
    IconChessHandAndBrain,
  },
  props: {
    variant: { type: String, required: true },
    color: { type: String, default: 'rgb(0,0,0)' },
    size: { type: String, default: '1em' },
    width: { type: String, default: null },
    height: { type: String, default: null },
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    iconComponent() {
      return VARIANT_COMPONENTS[this.variant] || null;
    },
  },
};
